const PROMO_IDS = {
  'pet-vet': { 'test-kits': 54, 'test-results': 55 },
  'ingredient-checker': { 'test-kits': 56, 'test-results': 57 },
  nutrable: { 'test-kits': 58, 'test-results': 59 },
};
const SIGNUP_PRODUCTS = { 46: 'pet-vet', 49: 'ingredient-checker', 52: 'nutrable' };
const ATTRIBUTION_WINDOW_MS = 30 * 60 * 1000;

export function trackPromoClick(product, source) {
  const activityTypeId = PROMO_IDS[product]?.[source];
  if (!activityTypeId) return;
  try {
    sessionStorage.setItem(`promo:${product}`, JSON.stringify({
      source, clickedAt: Date.now(), cid: localStorage.getItem('cid'),
    }));
  } catch { /* Tracking must not interrupt navigation when storage is unavailable. */ }
  return logActivity(activityTypeId);
}

function getPromoSource(activityTypeId) {
  const product = SIGNUP_PRODUCTS[activityTypeId];
  if (!product) return null;
  try {
    const attribution = JSON.parse(sessionStorage.getItem(`promo:${product}`));
    const age = Date.now() - attribution?.clickedAt;
    if (attribution?.cid === localStorage.getItem('cid') && age >= 0 && age <= ATTRIBUTION_WINDOW_MS
      && PROMO_IDS[product][attribution.source]) return attribution.source;
  } catch { /* A signup click can still be recorded without attribution. */ }
  return null;
}

export async function logActivity(activityTypeId) {
  const accessToken = localStorage.getItem('accessToken');
  const cid = localStorage.getItem('cid');

  if (!accessToken || !cid) return false;

  try {
    const response = await fetch(`${process.env.VUE_APP_API_URL}/api/activity`, {
      method: 'POST',
      credentials: 'include',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        cid,
      },
      body: JSON.stringify({ activityTypeId, promoSource: getPromoSource(activityTypeId) }),
    });

    return response.ok;
  } catch (error) {
    console.warn(`Could not log activity ${activityTypeId}:`, error);
    return false;
  }
}
